<template>
  <div>
    <h6><i class="vsm--icon fa fa-building"></i>
    <router-link class="title" event="" :to="{ name: 'organizationView', params: { id: item.id }}" @click.native.prevent="viewOrg">{{ item.name }}</router-link></h6>
    <p class="meta">
     <span class="meta-bit" v-if="item.country"> {{ item.country }}</span>
    </p>
    <p class="meta-desc" v-if="item.description">{{ item.description }}</p>
    <ul class="tags">
      <OrgtypeLabel :target="itemtype" v-show="item"/>
    </ul>
  </div>
</template>


<script>
import OrgtypeLabel from './OrgtypeLabel'
let parser = document.createElement('a')
export default {
  name: 'result',
  props: ['item'],
  components: { OrgtypeLabel },
  methods: {
    domainOf: url => ((parser.href = url), parser.hostname.replace(/^www\./, '')),
    viewOrg: function(){
        var event = new CustomEvent("openView", {
                detail: {
                  type:"Organisation",
                  id: this.item.id
                }
              });
          this.$emit('openView',event);
      }
      },
       computed: {
            itemtype(){
              return (this.item.type.constructor.name=="Array"? this.item.type.join() : this.item.type);
              
            }
       }
}
</script>

<style scoped>
  .meta {
    color: #777;
    font-size: .85em;
  }
  .meta-bit {
    color: #333;
    font-weight: bold;
  }
  
  .meta-desc{
    overflow:hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .vsm--icon{
    color:#afacac;
    margin-right:5px;
  } 

  .tags {
    margin: 0;
    padding: 0;
  }

   .tags li {
    list-style: none;
    padding: 0px 7px;
    display: inline-block;
    border-radius: 4px;
    background: #1D809F;
    color: #fff;
    margin-top: 5px;
    margin-right: 2px;
    font-size: 12px;
    border-radius: 13px;
    line-height: 27px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/OrgResult.vue